import UserAccessState from './UserAccessState';

export function install(Vue) {
  Vue.component(UserAccessState.name, UserAccessState);
}

export default { install };
export { UserAccessState };
